import Vue from 'vue';
// import { Carousel } from 'element-ui';
import App from './App.vue';
import router from './router';
import store from './store';
// 引入全局css
import './assets/scss/style.scss';

import ElementUI from 'element-ui';  
import 'element-ui/lib/theme-chalk/index.css';  
  
Vue.use(ElementUI);

import VueAnimateOnScroll from 'vue-animate-onscroll';

Vue.use(VueAnimateOnScroll);
import 'animate.css'
// 按需引入vue-awesome图标
// import Icon from 'vue-awesome/components/Icon';
// import 'vue-awesome/icons/chart-bar.js';
// import 'vue-awesome/icons/chart-area.js';
// import 'vue-awesome/icons/chart-pie.js';
// import 'vue-awesome/icons/chart-line.js';
// import 'vue-awesome/icons/align-left.js';

//引入echart
//4.x 引用方式
import echarts from 'echarts'


import VueAwesomeSwiper from 'vue-awesome-swiper';  
import 'swiper/swiper-bundle.css';
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
// Vue.use(Carousel)
// 全局注册
// Vue.component('icon', Icon);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
